module.exports = __webpack_public_path__ + "img/martha.6399e498.png";